import type { JSX } from 'react';
import { HookFormInput } from 'ts/commons/forms/HookFormInput';
import { RegexUtils } from 'ts/commons/RegexUtils';
import type { EBlacklistingOptionEntry } from 'typedefs/EBlacklistingOption';
import { EBlacklistingOption } from 'typedefs/EBlacklistingOption';
import styles from './BlacklistFilter.module.less';

/** Values provided by the BlacklistRationalFilter component. */
export type BlacklistRationalFilterValues = {
	/** Filter blacklist rationale for this FilterComponent. */
	blacklistRationale: string;
};

type BlacklistRationalFilterProps = {
	/**
	 * What kind of findings are currently shown. Determines whether the filter should actually be shown and with which
	 * label.
	 */
	blacklistFilter: EBlacklistingOptionEntry;
};

/**
 * Provides an input that allows to enter a regex by which findings will be filtered based on the blacklist rational.
 * The component will only work when wrapped in a FormProvider.
 */
export function BlacklistRationalFilter({ blacklistFilter }: BlacklistRationalFilterProps): JSX.Element | null {
	if (blacklistFilter === EBlacklistingOption.EXCLUDED.name) {
		return null;
	}
	return (
		<HookFormInput<BlacklistRationalFilterValues>
			fluid
			name="blacklistRationale"
			className={styles.blacklistFilter}
			label={
				blacklistFilter === EBlacklistingOption.ONLY_TOLERATED.name
					? 'Tolerated Rationale'
					: 'False Positive Rationale'
			}
			rules={{ validate: RegexUtils.validateJsRegex }}
		/>
	);
}
